import { Default_getInstancevb13yk0g3h3e as Default_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import {
  Companion_getInstance20bpwyuqfvwiw as Companion_getInstance,
  Messageyu2c6n5qdmq as Message,
} from './Message.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function formatMessage($this, $receiver) {
  var tmp = Default_getInstance();
  var tmp_0 = Companion_getInstance().serializer_9w0wvi_k$();
  var tmp0_safe_receiver = $receiver.payload_1;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(tmp0_safe_receiver.get_size_woubt6_k$()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = tmp0_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp_2 = element.get_key_18j28a_k$();
      // Inline function 'kotlin.collections.component2' call
      var value = element.get_value_j01efc_k$();
      var tmp$ret$4 = toString(value);
      destination.put_4fpzoq_k$(tmp_2, tmp$ret$4);
    }
    tmp_1 = destination;
  }
  var tmp_3 = tmp_1;
  var tmp_4 = System_instance.now_2cba_k$().toString();
  var tmp1_safe_receiver = $receiver.marker_1;
  return tmp.encodeToString_k0apqx_k$(tmp_0, new (Message())($receiver.level_1.name_1, $receiver.loggerName_1, $receiver.message_1, tmp_3, tmp_4, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.getName_18u48v_k$(), throwableToString($this, $receiver.cause_1)));
}
function throwableToString($this, $receiver) {
  if ($receiver == null) {
    return emptyList();
  }
  var msg = emptyList();
  var current = $receiver;
  while (!(current == null) && !equals(current.cause, current)) {
    msg = plus(msg, ", Caused by: '" + current.message + "'");
    current = current.cause;
  }
  return msg;
}
var JsonFormatterClass;
function JsonFormatter() {
  if (JsonFormatterClass === VOID) {
    class $ {
      formatMessage_52asgz_k$(loggingEvent) {
        return formatMessage(this, loggingEvent);
      }
      toString() {
        return 'JsonFormatter';
      }
      hashCode() {
        return -1288108928;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof JsonFormatter()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'JsonFormatter');
    JsonFormatterClass = $;
  }
  return JsonFormatterClass;
}
var JsonFormatter_instance;
function JsonFormatter_getInstance() {
  return JsonFormatter_instance;
}
//region block: init
JsonFormatter_instance = new (JsonFormatter())();
//endregion
//region block: exports
export {
  JsonFormatter_instance as JsonFormatter_instance2hc6t42c212a9,
};
//endregion

//# sourceMappingURL=JsonFormatter.mjs.map
